import { useContext } from "react";
import { CRFContext } from "./CRFContext";

export const useCRF = () => {
  const context = useContext(CRFContext);
  if (!context) {
    throw new Error("useCRF must be used within a CRFContext.Provider");
  }
  return context;
};
